// import React, { useState } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faUser, faUserTie, faTimes } from '@fortawesome/free-solid-svg-icons';
// import './roleoptionstyle.css';
// import SignUpForm from './Signup';
// import ServitorSignup from './ServitorSignup';

// const RoleOption = ({ onClose }) => {
//     const [selectedRole, setSelectedRole] = useState(null);
//     const [showSignUpForm, setShowSignUpForm] = useState(false);

//     const handleRoleSelection = (role) => {
//         setSelectedRole(role);
//         setShowSignUpForm(true);
//     }

//     const handleClose = () => {
//         setSelectedRole(null);
//         setShowSignUpForm(false);
//         onClose();
//     }

//     return (
//         <div className="role-popup">
//             <div className="role-popup-content">
//                 <div className="close-icon" onClick={handleClose}>
//                     <FontAwesomeIcon icon={faTimes} />
//                 </div>
//                 <div className="role-options">
//                     <h2>Choose your Role</h2>
//                     <hr />
//                     <div className="role-cards-container">
//                         <div className="role-card" onClick={() => handleRoleSelection('user')}>
//                             <FontAwesomeIcon icon={faUser} size="3x" />
//                             <h3>User</h3>
//                         </div>
//                         <div className="role-card" onClick={() => handleRoleSelection('servitor')}>
//                             <FontAwesomeIcon icon={faUserTie} size="3x" />
//                             <h3>Servitor</h3>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             {showSignUpForm && selectedRole === 'user' && <SignUpForm onClose={handleClose} />}
//             {showSignUpForm && selectedRole === 'servitor' && <ServitorSignup onClose={handleClose} />}
//         </div>
//     );
// }

// export default RoleOption;

// *** Upper RoleOption code all is working fine and perfect - last checked (18-6-25) *** //

// ***** Translate added EN-BN - (18-6-25) ***** //

// import React, { useState } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faUser, faUserTie, faTimes } from '@fortawesome/free-solid-svg-icons';
// import './roleoptionstyle.css';
// import SignUpForm from './Signup';
// import ServitorSignup from './ServitorSignup';
// import { useTranslation } from 'react-i18next';

// const RoleOption = ({ onClose }) => {
//     const { t } = useTranslation();

//     const [selectedRole, setSelectedRole] = useState(null);
//     const [showSignUpForm, setShowSignUpForm] = useState(false);

//     const handleRoleSelection = (role) => {
//         setSelectedRole(role);
//         setShowSignUpForm(true);
//     }

//     const handleClose = () => {
//         setSelectedRole(null);
//         setShowSignUpForm(false);
//         onClose();
//     }

//     return (
//         <div className="role-popup">
//             <div className="role-popup-content">
//                 <div className="close-icon" onClick={handleClose}>
//                     <FontAwesomeIcon icon={faTimes} />
//                 </div>
//                 <div className="role-options">
//                     {/* <h2>Choose your Role</h2> */}
//                     <h2>{t('role_option.choose_your_role')}</h2>
//                     <hr />
//                     <div className="role-cards-container">
//                         <div className="role-card" onClick={() => handleRoleSelection('user')}>
//                             <FontAwesomeIcon icon={faUser} size="3x" />
//                             {/* <h3>User</h3> */}
//                             <h3>{t('role_option.user_label')}</h3>
//                         </div>
//                         <div className="role-card" onClick={() => handleRoleSelection('servitor')}>
//                             <FontAwesomeIcon icon={faUserTie} size="3x" />
//                             {/* <h3>Servitor</h3> */}
//                             <h3>{t('role_option.servitor_label')}</h3>

//                         </div>
//                     </div>
//                 </div>
//             </div>
//             {showSignUpForm && selectedRole === 'user' && <SignUpForm onClose={handleClose} />}
//             {showSignUpForm && selectedRole === 'servitor' && <ServitorSignup onClose={handleClose} />}
//         </div>
//     );
// }

// export default RoleOption;

// ***** Upper code checked all okay (24-7-2025) ***** //

// ***** New design updated (24-7-2025) ***** //

// import React from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faUser, faUserTie, faTimes } from "@fortawesome/free-solid-svg-icons";
// import "./roleoptionstyle.css";
// import { useTranslation } from "react-i18next";

// const RoleOption = ({ onClose, onSelectRole }) => {
//   const { t } = useTranslation();

//   // const [selectedRole, setSelectedRole] = useState(null);
//   // const [showSignUpForm, setShowSignUpForm] = useState(false);

//   const handleRoleSelection = (role) => {
//     // setSelectedRole(role);
//     // setShowSignUpForm(true);
//     onClose(); // unmount the role picker
//     onSelectRole(role);
//   };

//   const handleClose = () => {
//     // setSelectedRole(null);
//     // setShowSignUpForm(false);
//     onClose();
//   };

//   return (
//     <div className="role-popup">
//       <div className="role-popup-content">
//         <div className="close-icon" onClick={handleClose}>
//           <FontAwesomeIcon icon={faTimes} />
//         </div>
//         <div className="role-options">
//           {/* <h2>Choose your Role</h2> */}
//           <h2>{t("role_option.choose_your_role")}</h2>
//           <hr />
//           <div className="role-cards-container">
//             <div
//               className="role-card"
//               onClick={() => handleRoleSelection("user")}
//             >
//               <FontAwesomeIcon icon={faUser} size="3x" />
//               {/* <h3>User</h3> */}
//               <h3>{t("role_option.user_label")}</h3>
//             </div>
//             <div
//               className="role-card"
//               onClick={() => handleRoleSelection("servitor")}
//             >
//               <FontAwesomeIcon icon={faUserTie} size="3x" />
//               {/* <h3>Servitor</h3> */}
//               <h3>{t("role_option.servitor_label")}</h3>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* {showSignUpForm && selectedRole === 'user' && <SignUpForm onClose={handleClose} />}
//           {showSignUpForm && selectedRole === 'servitor' && <ServitorSignup onClose={handleClose} />} */}

//     </div>
//   );
// };

// export default RoleOption;




// ***** New updated (8-sep-25) ***** //


import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUserTie, faTimes } from "@fortawesome/free-solid-svg-icons";
import "./roleoptionstyle.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const RoleOption = ({ onClose, onSelectRole }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // const [selectedRole, setSelectedRole] = useState(null);
  // const [showSignUpForm, setShowSignUpForm] = useState(false);

  const handleRoleSelection = (role) => {
    // setSelectedRole(role);
    // setShowSignUpForm(true);
    onClose(); // unmount the role picker
    // onSelectRole(role);

    if (role === "servitor") {
      navigate("/signup/servitor");   // ← go to full-page signup
    } else {
      onSelectRole(role);             // keep User overlay path
    }

  };

  const handleClose = () => {
    // setSelectedRole(null);
    // setShowSignUpForm(false);
    onClose();
  };

  return (
    <div className="role-popup">
      <div className="role-popup-content">
        <div className="close-icon" onClick={handleClose}>
          <FontAwesomeIcon icon={faTimes} />
        </div>
        <div className="role-options">
          {/* <h2>Choose your Role</h2> */}
          <h2>{t("role_option.choose_your_role")}</h2>
          <hr />
          <div className="role-cards-container">
            <div
              className="role-card"
              onClick={() => handleRoleSelection("user")}
            >
              <FontAwesomeIcon icon={faUser} size="3x" />
              {/* <h3>User</h3> */}
              <h3>{t("role_option.user_label")}</h3>
            </div>
            <div
              className="role-card"
              onClick={() => handleRoleSelection("servitor")}
            >
              <FontAwesomeIcon icon={faUserTie} size="3x" />
              {/* <h3>Servitor</h3> */}
              <h3>{t("role_option.servitor_label")}</h3>
            </div>
          </div>
        </div>
      </div>

      {/* {showSignUpForm && selectedRole === 'user' && <SignUpForm onClose={handleClose} />}
          {showSignUpForm && selectedRole === 'servitor' && <ServitorSignup onClose={handleClose} />} */}

    </div>
  );
};

export default RoleOption;
